import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import './index.css'
import App from './App.tsx'
import { wasPrerendered } from './lib/prerender'
import { preloadRoute } from './pages/routes'

function mount() {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </StrictMode>,
  )
}

// Past this, mount without the chunk rather than leave a page that never
// becomes interactive because a request hung without failing.
const PRELOAD_TIMEOUT_MS = 3000

if (wasPrerendered) {
  // Already in the pre-rendered HTML; kept here so the CSS in index.css
  // still applies if a snapshot was produced without it.
  document.documentElement.dataset.prerendered = 'true'
  // The page is already on screen; mount once its route chunk is here so
  // React replaces it with the same page, not a loading fallback. If the
  // chunk fails or stalls, mount anyway: the route shows its loading
  // fallback and, on a failed chunk, the error boundary.
  Promise.race([
    preloadRoute(window.location.pathname).catch((error: unknown) =>
      console.error('Route preload failed', error),
    ),
    new Promise<void>((resolve) => setTimeout(resolve, PRELOAD_TIMEOUT_MS)),
  ]).finally(mount)
} else {
  mount()
}
